import Swal from "sweetalert2";
import {
  ADDCONSULTANTBUSINESSPROFILE,
  ADDCONSULTANTINFORMATION,
  ADDCOURSE,
  ADDFRANCHISEIMG,
  ADDFRANCHISES,
  ADDFRANCHISESREQUIRENMENT,
  ADDFRANCHISESSUPPORT,
  ADDINSTITUTE,
  GETALLCONSULTANTBUSINESSPROFILE,
  GETCONSULTANTBUSINESSPROFILE,
  GETCONSULTANTENQUIRIES,
  GETCONSULTANTINFORMATION,
  GETCOURSES,
  GETCOURSESENQUIRIES,
  GETFRANCHISEENQUIRIES,
  GETFRANCHISEIMG,
  GETFRANCHISES,
  GETFRANCHISESREQUIRENMENT,
  GETFRANCHISESSUPPORT,
  GETINSTITUTE,
  requestCONSULTANt,
  UPDATECONSULTANTBUSINESSPROFILE,
  UPDATECONSULTANTINFORMATION,
  UPDATECOURSE,
  UPDATEFRANCHISEIMG,
  UPDATEFRANCHISES,
  UPDATEFRANCHISESREQUIRENMENT,
  UPDATEFRANCHISESSUPPORT,
  UPDATEINSTITUTE,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getConsultant = async (payload, callback) => {
  await axios
    .post(GETCONSULTANTINFORMATION, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const consultantUpdate = async (payload, callback) => {
  await axios
    .post(UPDATECONSULTANTINFORMATION, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const consultantAdd = async (payload, callback) => {
  await axios
    .post(ADDCONSULTANTINFORMATION, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const businessProfileAdd = async (payload, callback) => {
  await axios
    .post(ADDCONSULTANTBUSINESSPROFILE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getBusinessProfile = async (payload, callback) => {
  await axios
    .post(GETCONSULTANTBUSINESSPROFILE, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};
export const businessProfileUpdate = async (payload, callback) => {
  await axios
    .post(UPDATECONSULTANTBUSINESSPROFILE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAllConsultants = async (payload, callback) => {
  await axios
    .post(GETALLCONSULTANTBUSINESSPROFILE, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const getAllEnquiriesById = async (payload, callback) => {
  await axios
    .post(GETCONSULTANTENQUIRIES, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};



export const RequestConsultant = async (payload, callback) => {
  return axios
    .post(requestCONSULTANt, payload)
    .then((res) => {
      console.log(res)
      if (callback) callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Applied for job successfully",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};